<template>
  <div class="mb-4">
    <div
      class="d-flex align-items-center justify-content-center"
      v-if="carouselFiles.length == 0"
    >
      <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i> Betöltés
    </div>

    <section class="container" id="bannerek" v-if="carouselFiles.length != 0">
      <div
        id="carousel_1"
        class="carousel slide"
        data-ride="carousel"
        v-if="Object.keys(cities).length != 0"
      >
        <ol class="carousel-indicators">
          <!-- fix keko slider -->
          <li
            data-target="#carousel_keko"
            data-slide-to="carousel_keko"
            class="active"
          ></li>

          <li
            v-for="(city, index) in carouselFiles"
            :key="`banner-indicator-${city.name}-${index}`"
            :data-target="'#carousel_' + city.name"
            :data-slide-to="city.name"
          ></li>
        </ol>
        <div class="carousel-inner">
          <!-- fix keko slider -->
          <div class="carousel-item item active">
            <a
              class="d-block"
              href="/page/kozlekedesi-mobiljegy"
              style="height: 600px; text-align: center"
            >
              <img
                src="/img/fooldal_slider_villamos.jpg"
                data-length="5000"
                style="width: auto%; height: 100%"
              />
            </a>
          </div>

          <div
            v-for="(image, index) in carouselFiles"
            :key="`banner-inner-${image.name}-${index}`"
            class="carousel-item item"
          >
            <a
              class="d-block"
              :href="'#carousel_' + image.name"
              style="height: 600px; text-align: center"
            >
              <img
                :src="'data:' + image.type + ';base64, ' + image.content"
                :data-length="image.length"
                style="width: auto%; height: 100%"
              />
            </a>
          </div>
        </div>

        <a
          class="carousel-control-prev"
          href="#carousel_1"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Előző</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carousel_1"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Következő</span>
        </a>
      </div>
    </section>

    <section id="valasszon_varost" v-if="!loading">
      <div class="container">
        <h2>Válasszon várost:</h2>

        <div
          class="d-flex align-items-center justify-content-center"
          v-if="logoFiles.length == 0"
        >
          <i class="fa fa-spinner fa-spin mr-2" aria-hidden="true"></i> Betöltés
        </div>

        <div class="row justify-content-center" v-if="logoFiles.length != 0">
          <div
            class="col-md-4 col-sm-5 d-flex justify-content-center mb-4"
            v-for="logo in logoFiles"
            :key="logo.city_id"
          >
            <router-link
              :to="{ path: '/' + logo.slug }"
              class="text-center city-selector-logo"
            >
              <img
                :src="'data:' + logo.type + ';base64, ' + logo.content"
                :data-length="logo.length"
                style="max-width: 168px"
              />
              <h4>{{ logo.city_name }}</h4>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section id="mi_az_a_cityapp">
      <div class="container">
        <div class="row">
          <div class="col-lg-5"></div>
          <div class="col-lg-7">
            <h2>Mi az a CityApp?</h2>
            <p>
              A CityApp egy olyan mobil alkalmazás, aminek segítségével
              megismerheted a város híreit, intézményeit, sport létesítményeit,
              vendéglátóhelyeit, üzleteit és a helyi vállalkozók szolgáltatásait
              egy helyen, Android vagy iOS készülékeden.
            </p>

            <p>Elsőként értesülhetsz a friss információkról, hírekről.</p>

            <p>
              Bárhol és bármikor megtalálhatod, amire vágysz, amikor csak kedved
              tartja, beépített térképünk rögtön oda navigál.
            </p>

            <p>
              (Az alkalmazás használatához, a mobil-adatforgalom és
              helymeghatározás engedélyezése szükséges.)
            </p>

            <p>
              Minimum mobil operációs rendszerkövetelmény: Android 5.0 , iOS
              10.0
            </p>
          </div>
        </div>
      </div>
    </section>

    <section id="informaciok">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <img src="/img/kikapcsolodas_img.jpg" />
          </div>
          <div class="col-lg-6">
            <article id="kikapcsolodas">
              <h2>Kikapcsolódásra vágysz?</h2>
              <p class="article_body">
                Szeretnéd hasznosan eltölteni szabadidődet, de nincs ötleted? Az
                applikációban tájékozódhatsz az aktuális hírekről, programokról,
                kulturális- és sporteseményekről, rendezvényekről.
              </p>
            </article>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <article id="hol_egyek_ma">
              <h2>Hol egyek ma?</h2>
              <p class="article_body">
                Keresd a mobil alkalmazásban a város legjobb vendéglátóhelyeit,
                használd a kategóriaszűrőt!<br />
                Napi menük egy helyen!
              </p>
            </article>
          </div>
          <div class="col-lg-6">
            <img src="/img/kaja.png" />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <img src="/img/darts.jpg" />
          </div>
          <div class="col-lg-6">
            <article id="fodrasz_fogorvos">
              <h2>Fodrász, fogorvos, vízvezeték szerelő?</h2>
              <p class="article_body">
                Bármire is legyen szükséged, a CityApp mobil alkalmazásban
                számos üzlet és szolgáltatás közül válogathatsz,<br />
                keresd ezeket „Városi kisokos / Üzletek és Szabadidő”
                kategóriákban vagy használd a keresőt! A találatokat távolság
                szerint sorba rendezve kapod, elérhetőségekkel és
                térkép-nézettel kiegészítve.
              </p>
            </article>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <article id="toltsd_fel">
              <h2>Töltsd fel Te is díjmentesen vállalkozásodat!</h2>
              <p class="article_body">
                A Te üzleted, vállalkozásod is díjmentesen elérhetővé válhat, az
                ingyenesen letölthető CityApp mobilalkalmazás segítségével.<br />
                Válaszd ki városod, regisztrálj! Bejelentkezés után válaszd ki a
                vállalkozásodnak megfelelő kategóriát és töltsd fel
                vállalkozásod adatait, mely ellenőrzés után megjelenik az
                alkalmazásban, ez mely maximum 3 munkanapot vesz igénybe.
              </p>
            </article>
          </div>
          <div class="col-lg-6">
            <img src="/img/toltsd_fel_img.jpg" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: true,
      cities: {},
      logoFiles: [],
      headerFile: {},
      carouselFiles: [],
    };
  },
  methods: {
    getCities() {
      this.$store
        .dispatch("getCities")
        .then((response) => {
          if (response.status == 200) {
            this.cities = response.data;
            this.getImages();
          } else {
            this.error = response.data.message;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.message;
        });
    },
    getImages() {
      this.$store
        .dispatch("getHomeImages", null)
        .then((response) => {
          if (response.status == 200) {
            let images = response.data.data;

            for (let index in images) {
              switch (images[index].position) {
                case "LOGO":
                  this.logoFiles.push(images[index]);
                  break;
                case "HEADER":
                  this.headerFile = images[index];
                  break;
                case "CAROUSEL":
                  this.carouselFiles.push(images[index]);
                  break;
              }
            }
          } else {
            this.error = response.data.message;
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.message;
        });
    },
  },
  mounted() {
    this.getCities();
  },
};
</script>
